// app/ningenie/components/PWAMetaTags.tsx
// baby: Inject PWA meta tags directly into the head for ningenie routes

'use client'

import { useEffect } from 'react'

export const PWAMetaTags = () => {
  useEffect(() => {
    const ownedAttribute = 'data-ningenie-pwa-owned'

    // baby: Never remove head tags rendered by Next metadata.
    // baby: React/Next still owns those nodes, and deleting them manually can
    // baby: crash hydration in WebKit WebView with removeChild(null-parent).
    let manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement | null
    if (!manifestLink) {
      manifestLink = document.createElement('link')
      manifestLink.rel = 'manifest'
      manifestLink.setAttribute(ownedAttribute, 'true')
      document.head.appendChild(manifestLink)
    }
    manifestLink.href = '/ningenie-manifest.json'

    // baby: inject apple-mobile-web-app-title for iOS
    let appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]') as HTMLMetaElement | null
    if (!appleTitle) {
      appleTitle = document.createElement('meta')
      appleTitle.name = 'apple-mobile-web-app-title'
      appleTitle.setAttribute(ownedAttribute, 'true')
      document.head.appendChild(appleTitle)
    }
    appleTitle.content = 'NINGENIE'

    // baby: update page title
    if (document.title !== 'NINGENIE') {
      document.title = 'NINGENIE'
    }

    // baby: update theme-color meta tag to match app background
    // baby: calculate equivalent of #88a1ac18 (rgba with 9.4% opacity)
    // baby: #88a1ac18 over light bg (#f6f9fd) ≈ #f3f6f7
    // baby: #88a1ac18 over dark bg (#111319) ≈ #1c2026
    const getThemeColor = () => {
      const isDark = document.documentElement.classList.contains('dark')
      // baby: these are pre-calculated equivalents of #88a1ac18 composited over backgrounds
      return isDark ? '#1c2026' : '#f3f6f7'
    }
    
    const themeColor = getThemeColor()

    let themeColorMeta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null
    if (!themeColorMeta) {
      themeColorMeta = document.createElement('meta')
      themeColorMeta.name = 'theme-color'
      themeColorMeta.setAttribute(ownedAttribute, 'true')
      document.head.appendChild(themeColorMeta)
    }
    themeColorMeta.content = themeColor

    // baby: listen for theme changes and update to equivalent color
    const handleThemeChange = () => {
      const newThemeColor = getThemeColor()
      const themeMeta = document.querySelector('meta[name="theme-color"]')
      if (themeMeta) {
        themeMeta.setAttribute('content', newThemeColor)
      }
    }

    // baby: observe theme changes
    const observer = new MutationObserver(handleThemeChange)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    })

    return () => {
      // baby: cleanup on unmount
      observer.disconnect()
      const manifest = document.querySelector(`link[rel="manifest"][${ownedAttribute}="true"]`)
      if (manifest) manifest.remove()
      const apple = document.querySelector(`meta[name="apple-mobile-web-app-title"][${ownedAttribute}="true"]`)
      if (apple) apple.remove()
      const themeColor = document.querySelector(`meta[name="theme-color"][${ownedAttribute}="true"]`)
      if (themeColor) themeColor.remove()
    }
  }, [])

  return null
}

